import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { add, add_count, add_page } from '../../components/apipath';
import { switchHelper, dateHelper } from "../../modules/helpers";

function AddRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    // const navigate = useNavigate();
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);

    
    const fetchData = async (page = 1, rows = 50) => {
        try {
            setLoading(true);
            const response = await axios.get(`${add_page(page - 1, rows)}`, { headers: { token } });
            const data = response.data;
            console.log("Response Data (fetchData):", data); 
            setRequestList(data);
        } catch (error) {
            console.error('Error fetching request list:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPageData = async () => {
        try {
            const response = await axios.get(`${add_count}`, { headers: { token } });
            console.log("Response Data (fetchPageData):", response.data);
            if (response.data && response.data[0]) {
                setRowsCount(response.data[0].total || 0);
            }
        } catch (error) {
            console.error('Error fetching page data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchPageData();
    }, []);
    
    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    // 開始編輯
    const startEditing = (requestList) => {
        setEditingRequest(requestList);
        setUpdatedData(requestList);
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)) {
            setUpdatedData({
                add_id: editingRequest.add_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                add_id: editingRequest.add_id,
                ...updatedData,
                [name]: value,
            });
        }
    };

    // const formatToMysqlDatetime = (dateInput) => {
    //     const date = new Date(dateInput);
    //     const pad = (n) => (n < 10 ? '0' + n : n);
    //     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    //            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    // };
    
    
    // 更新申請記錄
    const saveChanges = async () => {
        try {
            const dataToSend = {
                add_id: updatedData.add_id,
                mem_id: updatedData.mem_id,
                add_on_items: updatedData.add_on_items,
                deliver: updatedData.deliver,
                address: updatedData.address,
                invoice: updatedData.invoice,
                address: updatedData.address,
                company_name: updatedData.company_name,
                company_tax: updatedData.company_tax,
                remit_name: updatedData.remit_name,
                memo: updatedData.memo || '',
                total_amount: updatedData.total_amount,
                status: updatedData.status || '審核中',
            };
    
            console.log("更新送出的資料:", dataToSend);
    
            const response = await axios.put(`${add}`, dataToSend, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    token: token
                  }
            });
    
            setRequestList(prevList =>
                prevList.map(req =>
                    req.add_id === updatedData.add_id ? response.data : req
                )
            );
    
        } catch (error) {
            console.error("更新失敗:", error);
        }
    };

    return (
        <>
            <div className="mt100 container-fluid p-5">
                <div className="mt-2">
                    <table className="table table-striped border table-responsive">
                        <thead>
                            <tr>
                                <th>學生姓名</th>
                                <th>加購項目</th>
                                <th>申請狀態</th>
                                <th>寄送地址</th>
                                <th>發票</th>
                                <th>抬頭</th>
                                <th>統編</th>
                                <th>匯款時間</th>
                                <th>匯款姓名</th>
                                <th>總金額</th>
                                <th>申請日期</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                        {requestList.map((request) => (
                                <tr key={request.add_id}>
                                    {editingRequest && editingRequest.add_id === request.add_id ? (
                                        <>
                                            <td colSpan={10}>
                                                <div className="container">
                                                    <div className="row g-1">
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請狀態</span>
                                                                <select
                                                                    className="form-select"
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="審核中">審核中</option>
                                                                    <option value="完成">完成</option>
                                                                    <option value="取消">取消</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td>{request.student_name}</td>
                                            <td>{request.add_on_items_name}</td>
                                            <td>{request.status}</td>
                                            <td>{request.address}</td>
                                            <td>{request.invoice}</td>
                                            <td>{request.company_name}</td>
                                            <td>{request.company_tax}</td>
                                            <td>{dateHelper(request.remit_time, "date")}</td>
                                            <td>{request.remit_name}</td>
                                            <td>{request.total_amount}</td>
                                            <td>{request.created_at}</td>
                                            <td>{request.memo}</td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={() => startEditing(request)}>
                                                    編輯
                                                </button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default AddRequest;
